import { createStore } from 'owa-satcheljs';
import type { MessageLayoutOptionsState } from './schema/MessageListLayoutState';

const messageListLayoutStore: () => MessageLayoutOptionsState =
    createStore<MessageLayoutOptionsState>('messageLayoutOptionState', {
        animationPreference: null,
        dateHeadersEnabled: null,
        inlinePreviewsEnabled: null,
        useSingleLineMessageStyle: null,
        showPreviewLinesInListView: null,
        tempPreviewLinesInListView: null,
        personaCheckboxDisplay: null,
        tempPersonaCheckboxDisplay: null,
        showSenderImageInListView: null,
        showSenderOnTopInListView: null,
    });

export default messageListLayoutStore;
